import styled, { css } from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  margin: 57px 0 0 60px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.pageBackground};
  align-items: center;
  padding: 10px 0;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInUp {
    animation-name: fadeInUp;
  }

  .fadeInDown {
    animation-name: fadeInDown;
  }

  .fadeIn {
    animation-name: fadeIn;
  }

  .animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  .delay-1 {
    animation-delay: 0.15s;
  }

  .delay-2 {
    animation-delay: 0.3s;
  }

  ${mediaMaxWidth.smallDesktop} {
    padding: 0;
  }

  ${mediaMaxWidth.tablet} {
    margin: 57px 0 0 0;
  }
`;

export const sharedMobileWidthStyles = css`
  ${mediaMaxWidth.mediumDesktop} {
    width: 900px;
  }

  ${mediaMaxWidth.smallDesktop} {
    width: calc(100vw - 80px);
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
  }
`;

export const About = styled.div`
  margin: 10px;
  padding: 10px;
  width: 960px;
  flex-direction: column;
  box-shadow: ${({ theme }) => theme.boxShadow};
  border-radius: ${({ theme }) => theme.borderRadius};
  background-color: ${({ theme }) => theme.colors.primary};
  background-image: ${({ theme }) =>
    `-webkit-linear-gradient(to right, ${theme.colors.primary}, ${theme.colors.secondary})`};
  background-image: ${({ theme }) =>
    `linear-gradient(to right, ${theme.colors.primary}, ${theme.colors.secondary})`};
  color: ${({ theme }) => theme.colors.white};

  ${sharedMobileWidthStyles}
`;

export const AboutTitle = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: ${({ theme }) => theme.colors.white};
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;

  ${mediaMaxWidth.tablet} {
    padding: 5px;
    font-size: 0.9em;
  }
`;

export const AboutText = styled.div`
  padding: 10px;

  span {
    font-weight: 700;
  }

  ${mediaMaxWidth.tablet} {
    font-size: 0.9em;
    padding: 5px;
  }
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 430px;

  input {
    width: 100%;
    margin: 0;
  }
`;

export const SearchRow = styled.div`
  width: 960px;
  display: flex;
  justify-content: flex-end;

  ${sharedMobileWidthStyles}
`;

export const ClearButton = styled.button`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border: none;

  svg.fa-times-circle {
    font-size: 1.2em;
  }

  &:hover {
    svg {
      color: #79D9D9;
    }
  }
`;

export const ListWrapper = styled.div`
  margin: 10px;
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 10px;
  width: 960px;
  flex-direction: column;
  box-shadow: ${({ theme }) => theme.boxShadow};
  border-radius: 8px;

  ${sharedMobileWidthStyles}
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;

  ${mediaMaxWidth.tablet} {
    display: none;
  }
`;

interface ITitleColumnProps {
  flex: number;
  center?: boolean;
}

export const TitleColumn = styled.div`
  display: flex;
  flex: ${(props: ITitleColumnProps) => props.flex};
  justify-content: ${(props: ITitleColumnProps) => props.center && "center"};
`;

export const List = styled.div`
  padding: 10px 0;
  display: flex;
  flex-direction: column;

  ${mediaMaxWidth.tablet} {
    padding: 5px;
  }
`;

export const Supplier = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px;
  margin: 2.5px 0;
  align-items: center;
  transition: all 0.1s ease-in-out;

  ${mediaMaxWidth.tablet} {
    padding: 5px 0;

    &:hover {
      background-color: ${({ theme }) => theme.colors.white};
    }
  }
`;

interface ISupplierColumnProps {
  flex: number;
  noMobile?: boolean;
  mobileAlignRight?: boolean;
}

export const SupplierColumnLink = styled.a`
  display: flex;
  flex: ${(props: ISupplierColumnProps) => props.flex};
  color: #000 !important;

  button {
    padding: 6px;

    ${mediaMaxWidth.tablet} {
      min-width: unset;
      font-size: 0.85em;
      padding: 4px 10px;
    }
  }

  &:hover {
    color: #79D9D9 !important;
  }

  ${mediaMaxWidth.tablet} {
    font-size: 0.85em;
    display: ${(props: ISupplierColumnProps) => props.noMobile && "none"};
    justify-content: ${(props: ISupplierColumnProps) =>
      props.mobileAlignRight && "flex-end"};
  }
`;

export const SupplierColumn = styled.div`
  display: flex;
  flex: ${(props: ISupplierColumnProps) => props.flex};

  button {
    padding: 6px;

    ${mediaMaxWidth.tablet} {
      min-width: unset;
      font-size: 0.85em;
      padding: 4px 10px;
    }
  }

  ${mediaMaxWidth.tablet} {
    font-size: 0.85em;
    display: ${(props: ISupplierColumnProps) => props.noMobile && "none"};
    justify-content: ${(props: ISupplierColumnProps) =>
      props.mobileAlignRight && "flex-end"};
  }
`;

export const NoPS = styled.div`
  padding: 10px 20px;
`;

export const ViewJobsLink = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  background: transparent;
  border: ${({ theme }) => `1px solid ${theme.colors.primary}`};
  font-weight: bold;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 22px;
  text-rendering: optimizeLegibility;
  padding: 10px 12px;
  font-family: ${({ theme }) => theme.fontFamily};
  text-align: center;
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1em;
  min-width: 100px;
  transition: 0.15s ease-in-out;

  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.white};
    background: #79D9D9;
    border: ${({ theme }) => `1px solid ${theme.colors.primary}`};
  }

  ${mediaMaxWidth.tablet} {
    min-width: unset;
    font-size: 0.85em;
    padding: 4px 10px;
  }
`;
